import type { FC } from 'react';

export interface Props {
  title?: string;
}

const SisuPageHead: FC<Props> = ({ title }) => {
  if (!title) {
    return null;
  }
  return <title>{title}</title>;
};
SisuPageHead.displayName = 'SisuPageHead';

export default SisuPageHead;
